import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';

export type EnumListItem = {
  code_type?: string;
  value: string;
  name: string;
  sort?: number;
  style_label?: string | null;
};

export type EnumListResult = {
  list: EnumListItem[];
};

export const enumApi = {
  getList: async (codeType: string): Promise<EnumListResult> => {
    const queryParams = new URLSearchParams();
    if (codeType) queryParams.append('codeType', codeType);

    const response = await fetch(`${API_ENDPOINTS.ENUM.LIST}?${queryParams}`, {
      headers: getAuthHeaders(),
    });
    const data = await handleResponse<EnumListResult | EnumListItem[]>(response);
    if (Array.isArray(data)) return { list: data };
    if (data && typeof data === 'object' && Array.isArray(data.list)) return data;
    return { list: [] };
  },
};
